import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { AiFillHome } from "react-icons/ai";
import { IoIosArrowForward } from "react-icons/io";
import InputField from "../../../../components/inputFields/InputField";
import TextareaField from "../../../../components/inputFields/TextField";
import Button from "../../../../components/buttons/Button";
import { addTutorialApi } from "../../../../services/apis/tutorials";
import showAlert from "../../../../components/errorBoundries/Errors";
import Toast from "../../../../components/toastify/Toast";
import { showSuccessToast } from "../../../../components/toastify/Toast";
import { useNavigate } from "react-router-dom";
import { get_user_id } from "../../../../constant/urls/localStoarege";

const AddTutorial = () => {
  const navigate = useNavigate();
  const userId = get_user_id();
  const [error, setError] = useState();
  const handleFormSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
        title: values.title,
        youtube_url: values.youtube_url,
        description: values?.text,
        created_by: userId,
      };

      const response = await addTutorialApi(payload);

      const responseData = response?.data;

      if (response?.status === 201) {
        showSuccessToast("Tutorial created successfully!");

        navigate("/tutorials");

        if (typeof resetForm === "function") {
          resetForm();
        }
      } else {
        let errors = "Opps! Something went wrong, please try again.";
        showAlert("Error", errors, "error");
      }
    } catch (error) {
      setError(
        error?.response?.data?.error ||
          "Opps! Something went wrong, please try again."
      );
      let errors =
        error?.response?.data?.error ||
        "Opps! Something went wrong, please try again.";
      showAlert("Error", errors, "error");
    }
    setSubmitting(false);
  };

  const handleDiscardChanges = (resetForm) => {
    navigate("/tutorials");
  };

  return (
    <div className="pl-5 ">
      {/* Top Section Begin */}
      <Toast />
      <div className="flex gap-3 items-center font-medium text-gray-500">
        <AiFillHome />
        <p>Home</p>
        <IoIosArrowForward />
        <p>Tutorials</p>
        <IoIosArrowForward />
        <p>Add New Tutorial</p>
      </div>
      {/* Top Section End */}
      {/* Form Begin */}
      <div className="mt-8">
        <Formik
          initialValues={{
            title: "",
            youtube_url: "",
            text: "",
          }}
          validationSchema={Yup.object({
            title: Yup.string().required("Please enter tutorial title"),
            youtube_url: Yup.string()
              .required("Please enter YouTube URL")
              .matches(
                /^(https?\:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+/,
                "Invalid YouTube URL"
              ),
            // text: Yup.string().required("Please enter tutorial text"),
          })}
          onSubmit={handleFormSubmit}
        >
          {({ isSubmitting, resetForm }) => (
            <Form>
              <div className="border border-gray-300 mt-5 p-4 rounded-lg bg-gray-100">
                <div className="w-full mb-1">
                  <InputField
                    label="Title"
                    name="title"
                    type="text"
                    placeholder="Enter title"
                    required
                  />
                </div>
                <div className="w-full mb-1">
                  <InputField
                    label="Youtube URL"
                    name="youtube_url"
                    type="text"
                    placeholder="Enter youtube url"
                    required
                  />
                </div>

                <div className="w-full mb-1">
                  <TextareaField
                    label="Text"
                    name="text"
                    placeholder="Enter tutorial text"
                    false
                  />
                </div>
              </div>
              <div className="py-5 flex justify-end gap-6">
                <div>
                  <Button
                    type="button"
                    className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                    onClick={() => handleDiscardChanges(resetForm)}
                    disabled={isSubmitting}
                  >
                    Discard Changes
                  </Button>
                </div>
                <div>
                  <Button
                    type="submit"
                    className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {/* Form End */}
    </div>
  );
};

export default AddTutorial;
